import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-bandas',
    templateUrl: './bandas.component.html',
    styleUrls: ['./bandas.component.css'],
    standalone: false
})
export class BandasComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private seo: SeoService
  ) {
    if (isPlatformBrowser(this.platformId)) window.scrollTo(0, 0);
   }

  ngOnInit(): void {
    this.seo.update({
      title: 'Bandas sinfonicas y educacion | Clave Winds',
      description: 'Soluciones para bandas sinfonicas, instituciones educativas y musicos de viento.',
      canonical: this.seo.absoluteUrl('/bandas')
    });
    
  }

}
